import { render, staticRenderFns } from "./crm-dashboard-tab.vue?vue&type=template&id=05767d1c&scoped=true&"
import script from "./crm-dashboard-tab.vue?vue&type=script&lang=js&"
export * from "./crm-dashboard-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05767d1c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05767d1c')) {
      api.createRecord('05767d1c', component.options)
    } else {
      api.reload('05767d1c', component.options)
    }
    module.hot.accept("./crm-dashboard-tab.vue?vue&type=template&id=05767d1c&scoped=true&", function () {
      api.rerender('05767d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-crm-app/rfi_process/tabs/crm-dashboard/crm-dashboard-tab.vue"
export default component.exports